import React from 'react';
import '../styles/Loading.css'

const Loading: React.FC = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
